import React from 'react';
import { Section } from './ui/Section';
export function FailedSolutions() {
  const failures = [{
    title: 'Hagamos una cita romántica',
    reason: 'se siente actuado si están agotados.'
  }, {
    title: 'Hay que ponerle ganas',
    reason: 'suena a deuda.'
  }, {
    title: 'Probemos cosas nuevas',
    reason: 'aumenta presión si no hay base segura.'
  }, {
    title: '¿Cuántas veces por semana…?',
    reason: 'convierte el deseo en KPI.'
  }];
  return <Section data-id="element-1">
      <h2 className="text-3xl md:text-4xl font-serif text-center text-[#2D2A26] mb-12" data-id="element-2">
        Lo que casi todos prueban <br data-id="element-3" />
        <span className="text-gray-500 text-2xl md:text-3xl italic" data-id="element-4">
          (y por qué falla)
        </span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-5">
        {failures.map((item, idx) => <div key={idx} className="bg-white p-6 border border-stone-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-6">
            <h3 className="font-serif text-lg font-semibold text-[#2D2A26] mb-2" data-id="element-7">
              "{item.title}"
            </h3>
            <div className="flex items-center gap-2 text-gray-600" data-id="element-8">
              <span className="text-[#C4A35A] text-xl" data-id="element-9">→</span>
              <span data-id="element-10">{item.reason}</span>
            </div>
          </div>)}
      </div>

      <p className="text-center text-xl font-medium text-[#2D2A26]" data-id="element-11">
        Y nadie quiere ser el proyecto de nadie.
      </p>
    </Section>;
}